import Reveal from "@/components/motion/Reveal";

const STATS = [
    ["$0", "de renta mensual", "Crear y mantener tu tienda no cuesta nada."],
    ["0%", "de comisión por venta", "No nos quedamos con un porcentaje de lo que vendes."],
    ["100%", "en línea", "Cobros con tarjeta y guías de envío, sin trámites en ventanilla."],
];

export default function PricingHighlight() {
    return (
        <section
            id="precios"
            data-testid="home-pricing"
            className="py-20 sm:py-28 lg:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mx-auto text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
                        Precios
                    </p>
                    <h2 className="mt-4 text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold tracking-[-0.03em] leading-[1.02] text-[#1A1A1A] text-balance">
                        Sin mensualidad. Sin comisión.
                    </h2>
                    <p className="mt-5 text-lg text-[#4A4A4A] leading-relaxed">
                        Solo pagas la comisión del procesador de pagos por cada
                        cobro con tarjeta y el costo del envío que elija tu
                        cliente. Nada más.
                    </p>
                </div>

                <div className="mt-16 grid sm:grid-cols-3 gap-10 lg:gap-14">
                    {STATS.map(([number, label, body], i) => (
                        <div key={label} className="text-center">
                            {/* La cifra es el mensaje: se descubre tras la máscara */}
                            <p className="text-6xl lg:text-7xl font-extrabold tracking-[-0.04em] text-[#1A1A1A] tabular-nums">
                                <Reveal variant="mask" delay={i * 0.12}>
                                    {number}
                                </Reveal>
                            </p>
                            <Reveal delay={i * 0.12 + 0.12}>
                                <p className="mt-3 text-base font-semibold text-[#1A1A1A]">
                                    {label}
                                </p>
                                <p className="mt-2 text-[15px] text-[#4A4A4A] leading-relaxed max-w-xs mx-auto">
                                    {body}
                                </p>
                            </Reveal>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
